import classnames from 'classnames'

const getClassNameFactory =
  (rootClass, styles, config = { baseClass: '' }) =>
  (options = {}, externalClassName = '') => {
    let internalClasses = ''

    if (typeof options === 'string') {
      // Handle string case - this is for descendant elements
      const descendant = options

      // Convert to PascalCase format for SCSS modules
      const pascalDescendant =
        descendant.charAt(0).toUpperCase() + descendant.slice(1)
      const className = styles[`${rootClass}${pascalDescendant}`]

      internalClasses = className ? config.baseClass + className : ''
    } else if (Array.isArray(options)) {
      // Handle array case - first item is the descendant, second is external className
      const [descendant, overrideClassName] = options

      // Convert to PascalCase format for SCSS modules
      const pascalDescendant =
        descendant.charAt(0).toUpperCase() + descendant.slice(1)
      const className = styles[`${rootClass}${pascalDescendant}`]

      internalClasses = className ? config.baseClass + className : ''
      externalClassName = overrideClassName || ''
    } else if (typeof options === 'object') {
      // Handle modifiers like { arrow: true, arrowOpen: item.isOpen }
      const modifiers = options
      const appliedClasses = {}

      // Add root class
      if (styles[rootClass]) {
        appliedClasses[styles[rootClass]] = true
      }

      // Process each modifier
      for (let modifier in modifiers) {
        if (!modifiers[modifier]) continue

        // Convert modifier to PascalCase
        const pascalModifier =
          modifier.charAt(0).toUpperCase() + modifier.slice(1)

        // Try to find class matching the modifier
        const modifierClassName = styles[`${rootClass}${pascalModifier}`]

        if (modifierClassName) {
          appliedClasses[modifierClassName] = true
        }
      }

      internalClasses = config.baseClass + classnames(appliedClasses)
    } else {
      // Just return root class
      internalClasses = config.baseClass + (styles[rootClass] || '')
    }

    // For resolving CSS precedence issues, we need to create a style element
    // with higher specificity for the external class if it exists
    if (externalClassName && typeof window !== 'undefined') {
      // Generate a unique ID for this style
      const styleId = `override-${externalClassName.replace(/[^a-z0-9]/gi, '')}`

      // Check if we already added this style
      if (!document.getElementById(styleId)) {
        const style = document.createElement('style')
        style.id = styleId
        style.innerHTML = `.${externalClassName} { color: inherit !important; background-color: inherit !important; }`
        document.head.appendChild(style)
      }
    }

    // Apply external className last
    return externalClassName
      ? `${internalClasses} ${externalClassName}`
      : internalClasses
  }

export default getClassNameFactory
